import { render, staticRenderFns } from "./AudioWithAliNLS.vue?vue&type=template&id=190e079b&scoped=true&"
import script from "./AudioWithAliNLS.vue?vue&type=script&lang=js&"
export * from "./AudioWithAliNLS.vue?vue&type=script&lang=js&"
import style0 from "./AudioWithAliNLS.vue?vue&type=style&index=0&id=190e079b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e079b",
  null
  
)

export default component.exports